import { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import LinkM from "@mui/material/Link";
import WestIcon from "@mui/icons-material/West";
import "./AdminAiInterviewList.css";
import Logout from "../../../CommonComponents/Logout/Logout";
import Notification from "../../../CommonComponents/Notification/Notification";
import AdminAiInterviewHiredTab from "./AdminAiInterviewHiredTab";
import AdminAiInterviewDashboardTab from "./AdminAiInterviewDashboardTab";
import { useOngoingDriveFilter } from "./useOngoingDriveFilter";

export function AdminAiInterviewList() {
  const [mainTab, setMainTab] = useState(0);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const driveFilter = useOngoingDriveFilter(setNotify);

  return (
    <Box className="ai-interview-main-container">
      <div className="ai-interview-top-bar">
        <div
          className="ai-interview-breadcrumbs"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Breadcrumbs aria-label="breadcrumb">
            <LinkM
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#fff",
                "&:hover": { textDecoration: "none", color: "#fff" },
              }}
              color="inherit"
              href="/admin-home"
            >
              <WestIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Home
            </LinkM>
            <LinkM
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#fff",
                "&:hover": { textDecoration: "none", color: "#fff" },
              }}
              color="inherit"
            >
              AI Interview
            </LinkM>
          </Breadcrumbs>
        </div>
        <div style={{ width: "10%" }}>
          <Logout />
        </div>
      </div>

      <Box className="ai-interview-container">
        <Box className="ai-interview-header">
          <span>AI Interview</span>
          <span className="ai-interview-subtitle">
            Monitor interviews, review appeals, and invite hired CrackIT candidates
          </span>
        </Box>

        <Tabs
          value={mainTab}
          onChange={(_, v) => setMainTab(v)}
          className="ai-interview-main-tabs"
        >
          <Tab label="Interview Monitor" />
          <Tab label="Hired Candidates" />
        </Tabs>

        {mainTab === 0 ? (
          <AdminAiInterviewDashboardTab
            setNotify={setNotify}
            driveFilter={driveFilter}
          />
        ) : (
          <AdminAiInterviewHiredTab
            setNotify={setNotify}
            driveFilter={driveFilter}
          />
        )}
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default AdminAiInterviewList;
